import React, { Fragment } from "react";

const ShareArticle = ({ setShowArticle }) => {
  return (
    <Fragment>
      <div className="share-article-overlay">
        <div className="share-article-box">
          <div className="input-container">
            <div className="round-input">
              <input
                type="text"
                className="search-site"
                name="share"
                placeholder="Search..."
              />
              <i className="fas fa-search magnifying green fa-lg"></i>
            </div>
            <i
              onClick={() => setShowArticle(false)}
              className="fas fa-times fa-3x search-x"
            ></i>
          </div>
          <div className="friends-body">
            <div className="user-results">
              <div className="single-section">
                <div className="friends-list">
                  <div className="list-name-container">
                    <p className="friend-bar"></p>
                    <p className="list-name">Friends</p>
                    <p className="friend-bar"></p>
                  </div>
                  <div className="friend-container">
                    <div className="friend-avi-container">
                      <div className="friend-avi"></div>
                    </div>
                    <div className="friend-user-info">
                      <ul className="friend-info-items">
                        <li className="friend-info-item">User Name</li>
                        <li className="friend-info-item">Job Title</li>
                        <li className="friend-info-item">Location</li>
                      </ul>
                    </div>
                    <div className="share-container">
                      <div className="shared-button">
                        <i className="fas fa-check mx-5"></i>Shared
                      </div>
                    </div>
                  </div>
                  <div className="friend-container">
                    <div className="friend-avi-container">
                      <div className="friend-avi"></div>
                    </div>
                    <div className="friend-user-info">
                      <ul className="friend-info-items">
                        <li className="friend-info-item">User Name</li>
                        <li className="friend-info-item">Job Title</li>
                        <li className="friend-info-item">Location</li>
                      </ul>
                    </div>
                    <div className="share-container">
                      <div className="share-button">Share</div>
                    </div>
                  </div>
                  <div className="friend-container">
                    <div className="friend-avi-container">
                      <div className="friend-avi"></div>
                    </div>
                    <div className="friend-user-info">
                      <ul className="friend-info-items">
                        <li className="friend-info-item">User Name</li>
                        <li className="friend-info-item">Job Title</li>
                        <li className="friend-info-item">Location</li>
                      </ul>
                    </div>
                    <div className="share-container">
                      <div className="share-button">Share</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="single-section">
                <div className="friends-list">
                  <div className="list-name-container">
                    <p className="friend-bar"></p>
                    <p className="list-name">Results</p>
                    <p className="friend-bar"></p>
                  </div>
                  <div className="friend-container">
                    <div className="friend-avi-container">
                      <div className="friend-avi"></div>
                    </div>
                    <div className="friend-user-info">
                      <ul className="friend-info-items">
                        <li className="friend-info-item">User Name</li>
                        <li className="friend-info-item">Job Title</li>
                        <li className="friend-info-item">Location</li>
                      </ul>
                    </div>
                    <div className="share-container">
                      <div className="shared-button">
                        <i className="fas fa-check mx-5"></i>Shared
                      </div>
                    </div>
                  </div>
                  <div className="friend-container">
                    <div className="friend-avi-container">
                      <div className="friend-avi"></div>
                    </div>
                    <div className="friend-user-info">
                      <ul className="friend-info-items">
                        <li className="friend-info-item">User Name</li>
                        <li className="friend-info-item">Job Title</li>
                        <li className="friend-info-item">Location</li>
                      </ul>
                    </div>
                    <div className="share-container">
                      <div className="shared-button">
                        <i className="fas fa-check mx-5"></i>Shared
                      </div>
                    </div>
                  </div>
                  <div className="friend-container">
                    <div className="friend-avi-container">
                      <div className="friend-avi"></div>
                    </div>
                    <div className="friend-user-info">
                      <ul className="friend-info-items">
                        <li className="friend-info-item">User Name</li>
                        <li className="friend-info-item">Job Title</li>
                        <li className="friend-info-item">Location</li>
                      </ul>
                    </div>
                    <div className="share-container">
                      <div className="share-button">Share</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ShareArticle;
